"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KHReference = void 0;
const KHEventHandler_1 = require("../KHEventHandler");
class KHReference extends KHEventHandler_1.KHEventHandler {
    constructor(value) {
        super();
        this.value = value;
    }
    set(value) {
        const changed = this.value !== value;
        this.value = value;
        if (changed) {
            this.emitEvent("valueChanged", { newValue: this.value });
        }
    }
    get() {
        return this.value;
    }
}
exports.KHReference = KHReference;
